<template>
    <div class="popover executive-popover" v-if="executive">
        <div class="header">
            <div class="details">
                <ExecutiveBadge :executive="executive" :hidePopover="true" :showPosition="true" />
            </div>
            <div class="rating" v-if="!executive.restricted && rating">
                <OverallRating :entity="executive" />
                <span>MTR</span>
            </div>
        </div>
        <div class="button-set">
            <router-link :to="`/executives/${executive.id}`" class="button secondary small"> View Profile </router-link>
            <WatchlistButton
                entity-type="Executive"
                :entity-id="executive.id"
                class="small"
                button-type="primary"
                v-if="!executive.restricted"
            />
        </div>
    </div>
</template>

<script setup>
import ExecutiveService from '@/services/executiveService'
import ExecutiveBadge from '@/components/executives/executive-badge'
import OverallRating from '../shared/overall-rating.vue'
import WatchlistButton from '@/components/shared/watchlist-button.vue'
import { computed } from 'vue'

const props = defineProps({
    value: {
        type: Object,
        default() {
            return {}
        },
    },
})

let __executive = null

import { asyncComputed } from '@/utils/asyncComputed'

const executive = asyncComputed(async () => {
    // check to see if we have an incomplete row; load the data
    // if something is missing
    if (props.value.ratings) {
        return props.value
    }

    if (__executive && __executive.id == props.value.id && __executive.ratings) {
        return __executive
    }

    try {
        const executive = await ExecutiveService.getSummary(props.value.id)

        if (executive?.id == props.value.id) {
            __executive = executive
        }
    } catch {}

    return __executive || props.value
}, props.value)

const rating = computed(() => executive.value?.ratings?.overall?.ratingValue?.toFixed(1))
</script>
